@if (screenSize !== 'mobile' || aboutView) {
  @if (!hasNewFooter) {
    <customer-portal-app-revolution-footer>
    </customer-portal-app-revolution-footer>
  }
  @if (hasNewFooter) {
    <customer-portal-app-footer-v2></customer-portal-app-footer-v2>
  }
}
